import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.link.js";
import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { breakpoints, typeScale } from 'styles/globals';
import { ArrowRight } from 'components/icons';
import TextLink from 'components/TextLink';
import Heading from 'components/Heading';
import PageTitle from 'components/PageTitle';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Crumb = styled(Heading).withConfig({
  displayName: "breadcrumbs__Crumb",
  componentId: "sc-vcq6t0-0"
})(["@media (max-width:", "){display:block;font-size:", ";font-weight:normal;}@media (max-width:", "){display:none;}"], breakpoints.s, typeScale.m, breakpoints.xxxs);
function Item(_ref) {
  var data = _ref.data,
    isLast = _ref.isLast;
  var link = data.link || '/browse';
  if (isLast) {
    return /*#__PURE__*/_jsx(PageTitle, {
      size: "large",
      display: "inline-block",
      verticalAlign: "middle",
      children: data.title
    });
  }
  return /*#__PURE__*/_jsxs(Crumb, {
    dimmed: true,
    size: "large",
    verticalAlign: "middle",
    display: "inline-block",
    forwardedAs: "span",
    children: [/*#__PURE__*/_jsx(TextLink, {
      stealthy: true,
      as: NavLink,
      to: link,
      children: data.title
    }), /*#__PURE__*/_jsx(ArrowRight, {
      vAlign: true,
      scale: 0,
      mx: "xs",
      dimmed: true
    })]
  });
}
function Breadcrumbs(_ref2) {
  var items = _ref2.items;
  return items.map(function (item, index) {
    return /*#__PURE__*/_jsx(Item, {
      data: item,
      isLast: index === items.length - 1
    }, item.key);
  });
}
export default Breadcrumbs;